import { useSuspenseQuery } from '@apollo/client'
import { AdminAPI, getFragment, SharedAPI } from '@guestgoodie/graphql'

export function usePms() {
  const { data, error } = useSuspenseQuery(AdminAPI.pms.GET, {
    errorPolicy: 'all'
  })

  if (error || !data) {
    if (error?.message !== 'not_found') throw error

    return null
  }

  return getFragment(SharedAPI.pms.PMS_FRAGMENT, data.getPms)
}

export function useIsConnected() {
  const pms = usePms()

  return !!pms?.isConnected
}
